<template>
  <div class="page">
    <div class="page-content">
  		<page-nav-bar currentServiceName="MoneyRoad" v-bind:subNavTitle="subNavTitle" ReturnButton></page-nav-bar>
      <div class="layoutTop"/>
      <div class="container-fluid">

        <div class="row">
          <div class="col-md-10 offset-md-1">
            <f7-list v-if="this.capsule === 'draft-edit'" class="draftTitle">
              <f7-list-item>
                <f7-label class="paymentsRequestSubOption formLabel formLabelPayment"><span class="color-red">* </span>{{ $t('creation_forms.drft_nm') }}</f7-label>
                <f7-input class="paymentsRequestSubOption" placeholder="Draft name" type="text" v-model="draftName"></f7-input>
              </f7-list-item>
            </f7-list>
          </div>
        </div>

        <div class="row">
          <div class="col-md-10 offset-md-1">
            <div class="panel21 panel-default">
              <div class="panel-heading">
                <h6 class="content-block labelAccordionForm creationFormTitle">
                  <img src='../../../assets/static/images/icons/inbox_out.png' class="formIcon"/>
                  {{ $t('common.new_item', {itemname : $t('servicesNames.dir_pymnts_sing') })}}
                </h6>
              </div>
              <ul v-if="accountType === '1'">
                <div class="accordion-item accordionForm accordion-item-expanded">
                  <a href="#" class="item-content item-link" @click="rotateChevron($event)">
                    <div class="item-inner" v-bind:class="colorBottomButton">
                      <div class="form-group row justify-content-start">
                        <div class="item-title createInvoiceBand col-sm-auto">
                          {{ $t('common.formsSubTitle.val_info') }}
                          <i class="f7-icons formChevron">chevron_right</i>
                        </div>
                      </div>
                    </div>
                  </a>

                  <div class="accordion-item-content">
                    <div class="form-group row">
                      <div class="test-title subtitleDebtorList col-4 col-sm-2 col-form-label labelAccordionForm" for="sel1" >
                        <span class="color-red">* </span>
                        {{ $t('common.team_label') }}
                      </div>
                      <div class="col-sm-4 showSmallScreenOnly form-group" :class='colorBottomButton'>
                        <div v-if="!readonly"
                             @click="teamPicker($event)"
                             class="button button-round button-inner-color buttonAccordionForm">
                          {{ $t('common.slct') }}
                        </div>
                      </div>
                      <div class="col-sm-12 showSmallScreenOnly">
                        <input class="form-control"
                               id="teamSelect" type="text"
                               v-model="label_team"
                               placeholder="Choose team"
                               readonly>
                        </input>
                      </div>
                      <div class="showLargeScreenOnly col-8 col-sm-10">
                          <b-form-select class="form-control" id="sel1"
                                         readonly v-model="id_team"
                                         :options="teamOptions">
                          </b-form-select>
                      </div>
                    </div>
                  </div>
                </div>
              </ul>

              <hr v-if="accountType === '1'"/>
              <ul>
                <div class="accordion-item accordionForm accordion-item-expanded">
                    <a href="#" class="item-content item-link" @click="rotateChevron($event)">
                      <div class="item-inner" v-bind:class="colorBottomButton">
                        <div class="form-group row justify-content-start">
                            <div class="item-title createInvoiceBand col-sm-auto">
                              {{ $t('common.formsSubTitle.dir_pymnt_sttngs') }}
                              <i class="f7-icons formChevron">chevron_right</i>
                            </div>
                        </div>
                      </div>
                  </a>

                  <div class="accordion-item-content">
                      <div class="form-group row">
                        <div class="col-sm-12" style="padding-left:1.5em">
                          <b-form-checkbox
                            v-model="instantPayment"
                            :disabled="readonly"
                            :value="1"
                            :unchecked-value="0">
                            {{ $t('creation_forms.inst_pymnt_form') }}
                          </b-form-checkbox>
                          <b-form-checkbox
                            v-model="decision"
                            :disabled="readonly"
                            :value="1"
                            :unchecked-value="0">
                            {{ $t('directPayments.dir_pymnt_decision_form') }}
                          </b-form-checkbox>
                          <b-form-checkbox
                            v-model="isOcrActive"
                            :disabled="readonly"
                            :value="true"
                            :unchecked-value="false"
                            style="margin-top: 2px;">
                            {{ $t('common.activate_OCR_form') }}
                          </b-form-checkbox>
                        </div>
                      </div>
                    </div>
                  </div>
              </ul>

              <hr>
              <ul>
                <div class="accordion-item accordionForm accordion-item-expanded">
                    <a href="#" class="item-content item-link" @click="rotateChevron($event)">
                      <div class="item-inner" v-bind:class="colorBottomButton">
                        <div class="form-group row justify-content-start">
                            <div class="item-title createInvoiceBand col-sm-auto">
                              {{ $t('common.formsSubTitle.bnk_trnsfr_ordr') }}
                              <i class="f7-icons formChevron">chevron_right</i>
                            </div>
                        </div>
                      </div>
                  </a>

                  <div class="accordion-item-content">
                      <div class="form-group row justify-content-start">
                        <div class="col-md-5 col-8" v-if="!readonly" v-bind:class="colorBottomButton">
                            <f7-button
                              class="button-round button-inner-color attachmentButton buttonAccordionForm longword-word"
                              @click="openImportAttachment()">
                              {{ $t('sent.import_bank_order_file') }}
                            </f7-button>
                        </div>
                        <div class="col-4 scanbutton" v-bind:class="colorBottomButton" v-if="!readonly && isSmartphoneOS">
                            <f7-button
                              class="button-round button-inner-color attachmentButton buttonAccordionForm"
                              @click="scanOrder($event)">
                              {{ $t('creation_forms.scn_ordr_forms') }}
                            </f7-button>
                        </div>
                      </div>
                      <div class="form-group row">
                        <div class="col-sm-12 ">
                          <input class="form-control inputAccordionForm" type="text"
                            placeholder="Select a file..."
                            readonly
                            v-model="attachementNameLabel" id="application-file-input"></input>
                          <input class="item-input hiddenElementAllSize local-file-input" @change="onFileChange" type="file"/>
                          <input class="hiddenElementAllSize" type="text"></input>
                          <input class="hiddenElementAllSize" type="text" id="recommendation-list-input"></input>
                        </div>
                      </div>
                      <div class="form-group row" v-if="(typeof attachmentName) !== 'undefined' && attachmentName !== ''">
                        <label class="col-4 col-sm-2 col-form-label labelAccordionForm">
                          {{ $t('common.rfrnc') }}
                        </label>
                        <div class="col-8 col-sm-10">
                          <input
                            :readonly="readonly"
                            class="form-control inputAccordionForm"
                            placeholder="Reference"
                            type="text"
                            v-model="attachmentReference">
                          </input>
                        </div>
                      </div>
                      <div v-if="!readonly" class=" form-group row" :class="colorBottomButton">
                        <div v-if="isSmartphone" class="col-md-4 offset-md-2">
                          <f7-button v-if="hasAttachment" class="button-round button-inner-color buttonAccordionForm attachmentButton" @click="view(attachmentId)">{{ $t('creation_forms.view_attchmnt') }}</f7-button>
                        </div>
                        <div v-if="!isSmartphone" class="col-md-4 offset-md-2">
                          <f7-button v-if="hasAttachment" class="button-round button-inner-color attachmentButton" @click="view(attachmentId)">{{ $t('creation_forms.dwnld_attchmnt') }}</f7-button> <!--Download-->
                        </div>
                        <div class="col-md-4">
                          <f7-button class="button-round button-inner-color attachmentButton" @click="clearAttachement()" v-if="(typeof attachmentName) !== 'undefined' && attachmentName !== ''">{{ $t('creation_forms.clear_label') }}</f7-button>
                        </div>
                      </div>
                      <div v-if="readonly && hasAttachment" class="row">
                        <div v-if="isSmartphone" class="col-md-4 offset-md2">
                          <f7-button class="button-round button-inner-color buttonAccordionForm attachmentButton" @click="view(attachmentId)">{{ $t('creation_forms.view_attchmnt') }}</f7-button>
                        </div>
                        <div v-if="!isSmartphone" class="col-md-4 offset-md2">
                          <f7-button class="button-round button-inner-color buttonAccordionForm attachmentButton" @click="view(attachmentId)">{{ $t('creation_forms.dwnld_attchmnt') }}</f7-button> <!--Download-->
                        </div>
                      </div>
                    </div>
                  </div>
                </ul>
                <hr/>

                <ul>
                  <div class="accordion-item accordionForm accordion-item-expanded">
                    <a href="#" class="item-content item-link" @click="rotateChevron($event)">
                      <div class="item-inner" v-bind:class="colorBottomButton">
                        <div class="form-group row justify-content-start">
                          <div class="item-title createInvoiceBand col-sm-auto text-uppercase">
                            <span class="color-red"> *</span>
                            {{ $t('common.formsSubTitle.item_info',
                              {itemname: $t(this.$engine.services.getLabelIdOne(this.$engine.user.currentService.id))}) }}
                            <i class="f7-icons formChevron">chevron_right</i>
                          </div>
                        </div>
                      </div>
                    </a>

                    <div class="accordion-item-content">
                        <div class="form-group">
                          <div class="row justify-content-start">
                            <div class="col-md-5 col-8" v-if="!readonly" v-bind:class="{blueBottomButton: isOcrActive, greyBottomButton: !isOcrActive}">
                              <input class="item-input hiddenElementAllSize rib-file-input" @change="executeOCROnRIB" type="file"/>
                              <f7-button
                                class="button-round button-inner-color attachmentButton buttonAccordionForm"
                                @click="importRIB($event)"
                                :disabled="!isOcrActive">
                                {{ $t('sent.import_RIB_btn',
                                  {contacttype: this.$i18n.t(this.$engine.services.getLabelIdOne(this.$engine.user.currentService.id))}) }}
                              </f7-button>
                            </div>
                            <div class="col-4 showSmallScreenOnly" v-bind:class="colorBottomButton" v-if="isOcrActive && isSmartphoneOS">
                              <f7-button class="button-round button-inner-color attachmentButton buttonAccordionForm scanbutton" @click="scanRIB($event)" >
                                {{ $t('sent.scan_RIB_btn') }}
                              </f7-button>
                            </div>
                          </div>
                          <!-- Ligne Select Beneficiary from List et bouton d'OCR depuis un .pdf -->
                          <div class="row" style="margin-top: 10px;">
                            <div class="col-md-5 col-8" v-bind:class="colorBottomButton">
                              <a v-if="!readonly" href="/directPayments/contactDebtorList/">
                                <span href="#" class="button button-round button-inner-color">
                                  {{ $t('sent.select_cntct_btn',
                                    {contacttype: this.$i18n.t(this.$engine.services.getLabelIdOne(this.$engine.user.currentService.id))}) }}
                                </span>
                              </a>
                            </div>
                          </div>
                        </div>
                        <div class="form-group row">
                          <label class="col-sm-2 col-4 col-form-label labelAccordionForm">
                            <span class="color-red">* </span>
                              {{ $t('common.nme') }}
                          </label>
                          <div class="col-8 col-sm-10">
                            <input :readonly="readonly" class="form-control inputAccordionForm" placeholder="Beneficiary name" type="text" v-model="beneficiaire"></input>
                          </div>
                        </div>
                        <div class="form-group row">
                          <label class="col-sm-2 col-4 col-form-label labelAccordionForm">
                            <span>
                              <span v-if="mandatoryDebtorEmail" class="color-red">* </span>
                              {{ $t('common.idtfr') }}
                            </span>
                          </label>
                          <div class="col-8 col-sm-10">
                            <input :readonly="readonly" class="form-control inputAccordionForm" placeholder="Beneficiary email / siren" v-model="recipientEmail"></input>
                          </div>
                        </div>
                        <div class="form-group row" v-if="!readonly && !contactSelected">
                          <div class="col-sm-2 col-4 col-form-label labelAccordionForm">
                            <span class="color-red">* </span>
                            {{ $t('common.account_zone') }}
                          </div>
                          <div class="col-6 showSmallScreenOnly form-group" :class='colorBottomButton'>
                            <div
                              v-if="!readonly"
                              @click="countriesPicker($event)"
                              class="button button-round button-inner-color buttonAccordionForm"
                              :placeholder="$i18n.t('zoneCodes.slct_zone')">
                              {{ $t('zoneCodes.slct_zone') }}
                            </div>
                          </div>
                          <div class="col-sm-12 showSmallScreenOnly">
                            <input class="form-control" id="ListCountry" type="text" placeholder="Select a zone ..." readonly></input>
                          </div>
                          <div class="col-sm-10 showLargeScreenOnly">
                            <select class="form-control" id="sel4" v-model="recipientZoneCode" readonly>
                              <option v-for="country in countries" :key="country.id"
                               :value="country"
                               :disabled="country.disabled"
                               :selected="country.selected">
                                {{ $t('zoneCodes.' + country.label) }}
                              </option>
                            </select>
                          </div>
                        </div>
                        <div
                          class="form-group row"
                          v-for="accountLabel in recipientZoneCode.accountLabel">
                            <label class="col-4 col-sm-2 col-form-label">
                              <span class="color-red">* </span>{{ $t(accountLabel) }}
                            </label>
                            <div class="col-8 col-sm-10">
                              <input
                                name="identifier"
                                class="form-control"
                                type="text"
                                :placeholder="$i18n.t(accountLabel)"
                                v-model="recipientZoneCode.values[accountLabel]">
                              </input>
                            </div>
                        </div>
                      </div>
                    </div>
                  </ul>
                  <hr/>

                  <ul>
                    <div class="accordion-item accordionForm accordion-item-expanded">
                      <a href="#" class="item-content item-link" @click="rotateChevron($event)">
                        <div class="item-inner" v-bind:class="colorBottomButton">
                          <div class="form-group row justify-content-start">
                            <div class="item-title createInvoiceBand col-sm-auto">
                              <span class="color-red"> *</span>
                                {{ $t('common.formsSubTitle.my_acc_info') }}
                              <i class="f7-icons formChevron">chevron_right</i>
                            </div>
                          </div>
                        </div>
                      </a>

                      <div class="accordion-item-content">
                        <div class="form-group row">
                          <div class="test-title subtitleDebtorList col-sm-2 col-4 col-form-label labelAccordionForm" for="sel2" >
                            <span class="color-red">* </span>
                            {{ $t('common.act') }}
                          </div>
                          <div class="col-6 showSmallScreenOnly form-group" :class="colorBottomButton">
                            <div v-if="!readonly" @click="accountPicker($event)" class="button button-round button-inner-color buttonAccordionForm">
                              {{ $t('common.slct') }}
                            </div>
                          </div>
                          <div class="col-sm-12 showSmallScreenOnly">
                            <input class="form-control" id="account-inputDP" type="text" v-model="senderBankName" placeholder="Choose account" readonly></input>
                          </div>
                          <div class="showLargeScreenOnly col-8 col-sm-10">
                            <select class="form-control" id="sel2" readonly v-model="senderBank">
                              <option value="">{{ $t('creation_forms.slct_an_acc') }}</option>
                              <option v-for="bankAccount in bankAccounts" :key="bankAccount.id" :value="bankAccount.iban">
                                {{bankAccount.name}} ({{ $engine.bankAccounts.getCurrency(bankAccount.zoneCode) }})
                              </option>
                            </select>
                          </div>
                        </div>
                      </div>
                    </div>
                  </ul>
                  <hr/>
                  <ul>
                    <div class="accordion-item accordionForm accordion-item-expanded">
                      <a href="#" class="item-content item-link" @click="rotateChevron($event)">
                        <div class="item-inner" v-bind:class="colorBottomButton">
                          <div class="form-group row justify-content-start">
                            <div class="item-title createInvoiceBand col-sm-auto" v-if="directPayments === '1'" @click="hideBlock($event)">>
                              <span class="color-red"> *</span>
                              {{ $t('common.formsSubTitle.dir_pymnts_dtls') }}
                              <i class="f7-icons formChevron">chevron_right</i>
                            </div>
                            <div class="item-title createInvoiceBand col-sm-auto"  v-else>
                              <span class="color-red"> *</span>
                              {{ $t('common.formsSubTitle.pymnts_req_dtls') }}
                              <i class="f7-icons formChevron">chevron_right</i>
                            </div>
                          </div>
                        </div>
                      </a>

                      <div class="accordion-item-content">
                        <div class="form-group row">
                          <label class="col-sm-2 col-4 col-form-label labelAccordionForm" v-bind:class="{redFont: remittanceInformationColor}">
                            <span class="color-red">* </span>
                            {{ $t('common.rsn') }}
                          </label>
                          <div class="col-8 col-sm-10">
                            <input :readonly="readonly" class="form-control" placeholder="Reason" type="text" v-model="remittanceInformation"></input>
                          </div>
                        </div>
                        <div class="form-group row">
                          <label class="col-sm-2 col-4 col-form-label labelAccordionForm" v-bind:class="{redFont: executionDateColor}">
                            <span class="color-red">* </span>
                            {{ $t('common.date_label') }}
                          </label>
                          <div v-if="hasDatePicker === true"
                            class="col-8 col-sm-10" style="width: 100%"
                            @click="calendar($event)">
                              {{paymentsDate()}}
                          </div>
                          <div class="col-8 col-sm-10" v-else>
                            <input
                              :readonly="readonly"
                              class="form-control"
                              type="date"
                              placeholder="Select a date"
                              v-model="executionDate">
                            </input>
                          </div>
                        </div>
                        <div class="form-group row">
                          <label class="col-sm-2 col-4 col-form-label labelAccordionForm" v-bind:class="{redFont: amountColor}">
                            <span class="color-red">* </span>
                            {{ $t('common.amnt') }}
                          </label>
                          <div class="col-8 col-sm-10">
                            <div class="input-group mb-3">
                              <input :readonly="readonly" class="form-control" :placeholder="$i18n.t('common.amnt')" type="number" v-model="amount"></input>
                              <div class="input-group-append">
                                <span class="input-group-text"><b>{{ senderCurrency }}</b></span>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>

                  </ul>
                  <hr v-if="validators.length > 0" />
                  <ul v-if="validators.length > 0">
                    <div class="accordion-item accordionForm accordion-item-expanded">
                      <a href="#" class="item-content item-link" @click="rotateChevron($event)">
                        <div class="item-inner">
                          <div class="form-group row justify-content-start">
                            <div v-if="isValidated === '1'" class="item-title createInvoiceBand col-sm-auto">
                              {{ $t('common.formsSubTitle.valid') }}
                              <i class="f7-icons formChevron recipientChevron">chevron_right</i>
                            </div>
                            <div v-else class="item-title createInvoiceBand col-sm-auto">
                              {{ $t('common.formsSubTitle.valid') }}
                              <i class="f7-icons formChevron recipientChevron">chevron_right</i>
                            </div>
                          </div>
                        </div>
                      </a>

                      <div class="accordion-item-content">
                        <div class="form-group row" v-for="validator in validators">
                          <label class="labelAccordionForm col-6 col-sm-6 col-form-label">
                            <i v-if="validator.idAccount !== ''" class="fa fa-check" style="font-size: 16px; color: green; padding-right:10px"/>
                            <i v-else class="fa fa-clock-o streammindBlueFont" style="font-size: 16px; padding-right:10px"/>
                            {{validator.groupLabel}}
                          </label>
                          <div v-if="validator.idAccount !== ''" class="col-6 col-sm-6 col-form-label labelAccordionForm" style="text-align:right">{{validator.horodatage | formatDateTime}}</div>
                          <div v-else class="col-5 col-sm-5 col-form-label labelAccordionForm" style="text-align:right">{{ $t('creation_forms.pndng') }}</div>
                          <span v-if="validator.idAccount !== ''" class="createInvoiceBand col-12 col-sm-12 col-form-label" style="text-align:right">{{validator.name}}</span>
                          <span v-else class="createInvoiceBand col-12 col-sm-12 col-form-label" style="text-align:right">---</span>
                        </div>
                      </div>
                    </div>
                  </ul>
                  <!--REFUSE DRAFT HISTORY-->
                  <hr v-if="versionNumber > 1" />
                  <ul v-if="versionNumber > 1">
                    <div class="accordion-item accordionForm accordion-item-expanded">
                      <a href="#" class="item-content item-link" @click="rotateChevron($event)">
                        <div class="item-inner">
                          <div class="form-group row justify-content-start">
                            <div class="item-title createInvoiceBand col-sm-auto">
                              {{ $t('creation_forms.rfsl_hstr') }}
                              <i class="f7-icons formChevron recipientChevron">chevron_right</i>
                            </div>
                          </div>
                        </div>
                      </a>

                      <div class="accordion-item-content">
                        <div class="form-group row">
                          <label class="labelAccordionForm col-12 col-sm-12 col-form-label">
                            {{ $t('creation_forms.vrsn') }} <b>{{parseInt(this.versionNumber)-1}}</b> {{ $t('creation_forms.rfsd_by') }} <b>{{this.refuseUsername}}</b> {{ $t('creation_forms.from') }} <b>{{this.refuseGroupLabel}}</b>.
                          </label>
                        </div>
                        <div class="form-group row">
                          <label class="labelAccordionForm col-12 col-sm-12 col-form-label">{{ $t('creation_forms.rsn_ws') }}:</label>
                          <label class="labelAccordionForm col-12 col-sm-12 col-form-label">
                            Reason was:
                          </label>
                          <label class="labelAccordionForm col-12 col-sm-12 col-form-label">
                            {{this.refuseReason}}
                          </label>
                        </div>
                      </div>
                    </div>
                  </ul>
                </div>
              </div>
            </div>

            <div class="row justify-content-start"  v-bind:class="colorBottomButton">
              <div class="col-md-1"/>
              <div class="col-md" v-if="!readonly">
                <button round v-bind:class="savePosition" class="button-action firstButtonMarginTop" @click="getNameDraft">
                  <i class="icon fa fa-save"></i>
                  {{ $t('creation_forms.sv_rqust') }}
                </button>
              </div>
              <div class="col-md">
                <button round
                v-if="printValidateButton"
                class="button-action firstButtonMarginTop"
                @click="refuseDraft">
                  <i class="icon fa fa-ban"></i>
                  {{ $t('common.refus') }}
                </button>
              </div>
              <div class="col-md"
                v-if="(accountType === '2' ||
                      ((clearance === '1' | clearance === '2') &&
                      isValidated === '1')) || printValidateButton">
                <button round
                  v-if="accountType === '2' ||
                        ((clearance === '1' | clearance === '2') &&
                        isValidated === '1')"
                  class="button-action firstButtonMarginTop col-md"
                  @click="sendDirectPayments">
                  <i class="icon fa fa-paper-plane"></i>
                  {{ $t('creation_forms.snd_rqust') }}
                </button>
                <button round
                v-if="printValidateButton"
                class="button-action firstButtonMarginTop col-md"
                @click="valideDraft">
                  <i class="fa fa-check"></i>
                  <span>{{ $t('creation_forms.vldt') }}</span>
                </button>
              </div>
              <div class="col-md"
              v-if="printValidateButton && ableToValidateAndSend">
                <button round
                class="button-action firstButtonMarginTop col-md"
                @click="valideAndSendDraft">
                  <i class="icon fa fa-paper-plane"></i>
                  {{ $t('creation_forms.vldt_and_snd') }}
                </button>
              </div>
              <div class="col-md-1"/>
            </div>
            <div class="row">
              <div class="toolbarPageBottomBlank"></div>
            </div>
          </div>
        </div>
    </div>
  </div>
  </div>
</template>

<script>
import moment from 'moment'
import * as JsPDF from 'jspdf'
import b64toBlob from 'b64-to-blob'
// import {get} from '@/helpers/api'
import {errorMessageAlert} from '@/helpers/alert'
import pageNavBar from '@/components/common/pageNavBar.vue'
import {validateAccountFormat, validateEmail, validateSIREN} from '@/helpers/validator'
import bottomToolbar from '@/components/bottomToolbar/bottomToolbar.vue'
import datePickerMixin from '@/mixins/datePickerMixin'
import {createIbanUK, createForeignIban, extractForeignIban} from '@/helpers/format'
// import PaymentsSentboxPage from '@/pages/services/payments/CMSendboxPage.vue'
// import {getPayments} from '@/helpers/payments'
import {loadPage} from '@/helpers/routing'
// import _ from 'lodash'

export default {
  mixins: [datePickerMixin],
  name: 'writePayments',
  props: ['subNavTitle', 'capsule', 'saveMessage'],
  data () {
    return {
      colorBottomButton: this.$engine.services.getButtonClassColorById(this.$engine.user.currentService.id),
      isSmartphone: false,
      isSmartphoneOS: false,
      identifier: '',
      idDraft: '',
      beneficiaire: '',
      recipientBankAccount: '',
      recipientName: '',
      recipientBank: '',
      recipientEmail: '',
      senderBank: '',
      senderBankName: '',
      remittanceInformation: '',
      executionDate: '',
      amount: '',
      modificationAccepted: false,
      attachement: '',
      attachmentName: '',
      attachmentReference: '',
      attachmentId: '',
      loadingFile: false,
      fromCloud: false,
      bankAccounts: [],
      contacts: [],
      contactSelectionList: [],
      contactsObject: {},
      cloudFiles: [],
      ImmPmtAccepted: false,
      cloudDocsPicker: '',
      contactsPicker: '',
      accountsPicker: '',
      selected: null,
      selectedDebtor: {},
      enteredDebtors: [],
      sendPaymentsClicked: false,
      directPayments: '0',
      ccy: '€',
      clearance: '',
      draftName: '',
      recipientZoneCode: {
        id: 0,
        label: 'slct_zone',
        disabled: true,
        selected: true
      },
      sortCode: '',
      accountNumber: '',
      abaNumber: '',
      bsbNumber: '',
      isComplete: '',
      isValidated: '',
      isValidator: '',
      validators: [],
      validatorsGroups: '',
      idGroup: '',
      accountType: '',
      teamsPicker: '',
      teams: [],
      id_team: '',
      label_team: '',
      isOcrActive: false,
      hasAttachment: false,
      versionNumber: '1',
      refuseGroupLabel: '',
      refuseUsername: '',
      refuseReason: '',
      ableToValidateAndSend: false,
      teamOptions: [],
      hasCloudAttachments: false,
      contactSelected: false,
      countries: '',
      countryPicker: '',
      instantPayment: 0,
      decision: 0,
      currency: ''
    }
  },
  computed: {
    attachementNameLabel () {
      if (this.attachmentName === '' && this.isSmartphone) {
        return this.$i18n.t('creation_forms.imprt_or_scn_file')
      } else if (this.attachmentName === '') {
        return this.$i18n.t('creation_forms.imprt_file')
      } else {
        return this.attachmentName
      }
    },
    remittanceInformationColor () {
      return this.remittanceInformation === '' && this.sendPaymentsClicked
    },
    amountColor () {
      return this.amount === '' && this.sendPaymentsClicked
    },
    executionDateColor () {
      return (this.executionDate === '' || this.executionDate === this.$i18n.t('creation_forms.invld_dt')) && this.sendPaymentsClicked
    },
    savePosition: function () {
      return {
        leftfav2: this.accountType === '2' ||
                  (this.isValidated === '1' && (this.clearance === '1' || this.clearance === '2')) ||
                  (this.accountType === '1' && this.isComplete === '1' &&
                    (this.isValidated === '0' || this.isValidated === '2'))
      }
    },
    mandatoryDebtorEmail () {
      let decision = this.$engine.settings.directPayments.get().decision_creancier
      return decision !== '0'
    },
    printValidateButton () {
      let decision = this.accountType === '1' &&
            ((this.isValidated === '0' || this.isValidated === '2') &&
            (this.isComplete === '1') &&
            this.isValidator === true)
      return decision
    },
    readonly () {
      return this.accountType === '1' && this.isComplete === '1' && (this.isValidated === '1' || this.isValidated === '2')
    },
    senderZoneCodeLabel () {
      if (this.senderBank !== '') {
        return this.bankAccounts.filter(bkAct => { return bkAct.iban === this.senderBank })[0].zoneCode
      } else {
        return this.$i18n.t('zoneCodes.EUR')
      }
    },
    senderCurrency () {
      return this.$engine.bankAccounts.getCurrency(this.senderZoneCodeLabel)
    }
  },
  mounted () {
    this.$engine.services.directPayments.contactDebtorList = []
    if (this.accountType === '1') {
      if (this.capsule === 'draft-edit') {
        this.createTeamPicker()
      } else {
        this.$engine.accounts.fetchPersonnalTeams().then(() => { this.createTeamPicker() })
      }
    }
    /* TLV 18/12/2019
    * Sur grand écran, les accordéons sont étendus par défaut, tandis qu'ils sont repliés sur mobile
    */
    if (!this.$engine.services.directPayments.filter.smartphoneStorage) {
      this.$$('.accordionForm').addClass('accordion-item-expanded')
      this.$$('.formChevron').transform('rotate(90deg)')
    }
    // Guangze: get default modificationAccepted value
    this.modificationAccepted = this.$engine.settings.get().defaultNegotiationAllowed === '1'
    if (this.modificationAccepted) {
      this.Dom7('.checkboxModificationAccepted').prop('checked', true)
    }

    this.ableToValidateAndSend = this.calcValidateAndSend()

    /* IRY 04/2020 Par défaut le compte recipient est 'EU' */
    this.recipientZoneCode = this.$engine.bankAccounts.getZoneData('EUR')
    this.recipientZoneCode.values = {}
  },
  created () {
    let that = this
    this.setTeams()

    // Valeur par défaut de Instant Payment
    this.instantPayment = this.$engine.settings.directPayments.get().pacs008
    // Valeur par défaut de Decision Receiver
    this.decision = this.$engine.settings.directPayments.get().decision_creancier

    that.countries = this.$engine.bankAccounts.getZoneCode()
    if (that.$engine.services.directPayments.filter.smartphoneStorage) {
      that.isSmartphone = true
    }

    /** TLV 30/03/2020
    * isSmartphoneOS ne doit être activé QUE si l'utilisateur est sur un smartphone
    * Il ne doit jamais passer à true si l'utilisateur est sur son PC
    * (Pour afficher le bouton "Scan" qui accès à la camera du smartphone)
    */
    if (that.$f7.device.os === 'android' || that.$f7.device.os === 'ios') {
      this.isSmartphoneOS = true
    }

    if (this.$engine.settings.directPayments.get().ocrActivation === '1') {
      this.isOcrActive = true
    }

    that.payNumber = 1

    this.$f7.params.swipePanel = that.$engine.services.directPayments.filter.smartphoneStorage ? 'left' : false
    this.$f7.params.panelsCloseByOutside = that.$engine.services.directPayments.filter.smartphoneStorage
    // refresh-debtor-contact-list
    this.$bus.$on('refresh-contact-payments', (data) => {
      this.recipientName = data.debtorName
      this.recipientBankAccount = data.debtorBank
      this.recipientEmail = data.debtorEmail
    })
    this.enteredDebtors = this.$engine.services.payments.debtorList
    // TODO : selected
    // this.selected = this.$engine.services.payments.contactDebtorList
    this.selected = ''
    this.$engine.services.payments.contactDebtorList = []
    this.$engine.services.payments.contactGroupsSelected = []
    // this.contacts = this.$settings.currentAccount.contacts
    this.contacts = this.$engine.contacts.get()
    for (var i = 0; i < that.contacts.length; i++) {
      that.contactsObject[that.contacts[i].id] = that.contacts[i]
    }
    this.setContacts()
    this.$bus.$on('refresh-debtor-contact-list', (data) => {
      that.selected = data
      that.selectedDebtor = {}
      that.selectedDebtor = that.contactsObject[this.selected]
      that.beneficiaire = that.selectedDebtor.name
      that.recipientEmail = that.selectedDebtor.identifier
      this.recipientBankAccount = that.selectedDebtor.iban
      that.recipientZoneCode = this.$engine.bankAccounts.getZoneData(that.selectedDebtor.zoneCode)

      /** TLV 19/03/2020
      * On extrait les donnees du faux IBAN en base en vraies donnees bancaires,
      * en fonction du pays, dans une variable locale appelee extractedBankData
      * qui permet d'afficher sur le formulaire les IBAN en fonction des pays
      */
      let extractedBankData = {}
      if (this.recipientZoneCode !== '' && this.recipientBankAccount !== '') {
        extractedBankData = extractForeignIban(this.recipientBankAccount, that.selectedDebtor.zoneCode)
        console.log(extractedBankData)
      }
      let datavalues = {}
      for (var bankData in extractedBankData) {
        datavalues[extractedBankData[bankData].labelId] = extractedBankData[bankData].value
      }
      that.recipientZoneCode.values = datavalues
      that.contactSelected = true
    })
    this.loadingFile = false
    this.fromCloud = false
    // Date execution = aujourd'hui + 1 jour par défaut (demandé par un client)
    this.executionDate = moment().add(1, 'days').format('YYYY-MM-DD')

    this.bankAccounts = this.$engine.bankAccounts.get()
    // TLV 28/01/2020 : Compte par défaut sur le formulaire
    this.senderBank = this.bankAccounts.filter(bkAct => { return bkAct.isDefault === '1' })
    if (this.senderBank.length > 0) {
      this.senderBank = this.senderBank[0].iban
    } else {
      this.senderBank = ''
    }

    this.senderBankName = ''
    that.attahmentName = 'File'
    if (typeof (this.$settings.preChargedFile) !== 'undefined') {
      if (this.$settings.preChargedFile.fromCloudList === true) {
        this.fromCloud = true
        this.attachmentId = this.$settings.preChargedFile.id
        this.attachmentName = this.$settings.preChargedFile.name
        this.attachement = this.$settings.preChargedFile.data
        this.attachmentReference = this.$settings.preChargedFile.reference
        this.amount = this.$settings.preChargedFile.amount
        this.executionDate = this.$settings.preChargedFile.executionDate
        this.beneficiaire = this.$settings.preChargedFile.beneficiaire
        this.recipientEmail = this.$settings.preChargedFile.debtorEmail
        this.recipientBankAccount = this.$settings.preChargedFile.recipientBankAccount
        this.remittanceInformation = this.$settings.preChargedFile.remittanceInformation
        if (this.beneficiaire !== '' && this.recipientEmail === '') {
          for (i = 0; i < this.contacts.length; i++) {
            if (this.contacts[i].name === this.$settings.preChargedFile.beneficiaire) {
              that.beneficiaire = this.contacts[i].name
              that.recipientBankAccount = this.contacts[i].iban
              that.recipientEmail = this.contacts[i].identifier
            }
          }
        }
      }
    }
    this.$settings.preChargedFile = undefined
    /** TLV 26/09/2019
    * Correction de l'erreur de chargement de draft quand le draft est vide
    * dû au fait que le preChargedDraft était vidé sans être empty au onDestroy()
    */
    /** IRY 09/10/2019
    * Modification de la condition : les données du draft ne se chargeaient pas s'il n'y avait pas de PJ
    */
    if (typeof (this.$settings.preChargedDraft) !== 'undefined') {
      for (let i = 0; i < this.bankAccounts.length; i++) {
        if (this.bankAccounts[i].iban === this.$settings.preChargedDraft.DebtorBankAccount) {
          this.senderBankName = this.bankAccounts[i].name
        }
      }
      if (this.$settings.preChargedDraft.AttachmentId !== '') {
        this.attachmentId = this.$settings.preChargedDraft.AttachmentId
      }
      if (this.$settings.preChargedDraft.AttachmentName !== '') {
        this.attachmentName = this.$settings.preChargedDraft.AttachmentName
      }
      if (this.$settings.preChargedDraft.Attachment !== '' && this.$settings.preChargedDraft.Attachment !== '$NotFound') {
        this.attachement = this.$settings.preChargedDraft.Attachment
      }
      if (this.$settings.preChargedDraft.AttachmentReference !== '') {
        this.attachmentReference = this.$settings.preChargedDraft.AttachmentReference
      }
      if (this.$settings.preChargedDraft.CreditorName !== '') {
        this.beneficiaire = this.$settings.preChargedDraft.CreditorName
      }
      if (this.$settings.preChargedDraft.CreditorBankAccount !== '') {
        this.recipientBankAccount = this.$settings.preChargedDraft.CreditorBankAccount
      }
      if (this.$settings.preChargedDraft.CreditorIdentifier !== '') {
        this.recipientEmail = this.$settings.preChargedDraft.CreditorIdentifier
      }
      if (this.$settings.preChargedDraft.DebtorBankAccount !== '') {
        this.senderBank = this.$settings.preChargedDraft.DebtorBankAccount
      }
      if (this.$settings.preChargedDraft.RemittanceInformation !== '') {
        this.remittanceInformation = this.$settings.preChargedDraft.RemittanceInformation
      }
      if (this.$settings.preChargedDraft.RequestedExecutionDate !== '') {
        this.executionDate = this.$settings.preChargedDraft.RequestedExecutionDate
      }
      if (this.$settings.preChargedDraft.Amount !== '') {
        this.amount = this.$settings.preChargedDraft.Amount
      }
      if (this.$settings.preChargedDraft.ModificationAccepted === 'true') {
        this.modificationAccepted = true
      } else if (this.$settings.preChargedDraft.ModificationAccepted === 'false') {
        this.modificationAccepted = false
      }
      if (this.$settings.preChargedDraft.creditorEmail !== '') {
        this.creditorEmail = this.$settings.preChargedDraft.CreditorIdentifier
      }
      if (this.$settings.preChargedDraft.draftName !== '') {
        this.draftName = this.$settings.preChargedDraft.draftName
      }
      if (this.$settings.preChargedDraft.isComplete !== '') {
        this.isComplete = this.$settings.preChargedDraft.isComplete
      }
      if (this.$settings.preChargedDraft.isValidated !== '') {
        this.isValidated = this.$settings.preChargedDraft.isValidated
      }
      if (this.$settings.preChargedDraft.isValidator !== '') {
        this.isValidator = this.$settings.preChargedDraft.isValidator
      }
      if (this.$settings.preChargedDraft.idGroup !== '') {
        this.idGroup = this.$settings.preChargedDraft.idGroup
      }
      this.idDraft = this.$settings.preChargedDraft.idDraft

      this.recipientZoneCode = this.$engine.bankAccounts.getZoneData(this.$settings.preChargedDraft.recipientZoneCode)
      if (this.$settings.preChargedDraft.recipientZoneCode != null && this.$settings.preChargedDraft.recipientZoneCode !== '') {
        this.recipientZoneCode = this.$engine.bankAccounts.getZoneData(this.$settings.preChargedDraft.recipientZoneCode)
      }
      // this.recipientZoneCode.currencyLabel = this.$settings.preChargedDraft.currency
      if (this.recipientZoneCode.label === 'GBP' && this.recipientBankAccount !== '') {
        let extracted = extractForeignIban(this.recipientBankAccount)
        this.sortCode = extracted.sortCode
        this.accountNumber = extracted.accountNumber
        this.recipientBankAccount = ''
      }

      if (typeof (this.$settings.preChargedDraft.validators) !== 'undefined') {
        this.validators = this.$settings.preChargedDraft.validators
      }
      if (this.$settings.preChargedDraft.validatorsGroups !== undefined) {
        this.validatorsGroups = this.$settings.preChargedDraft.validatorsGroups
      }

      if (this.$settings.preChargedDraft.idTeam !== undefined) {
        this.id_team = this.$settings.preChargedDraft.idTeam
      }

      if (this.$settings.preChargedDraft.versionNumber !== undefined) {
        this.versionNumber = this.$settings.preChargedDraft.versionNumber
      }

      if (this.$settings.preChargedDraft.refuseGroupLabel !== undefined) {
        this.refuseGroupLabel = this.$settings.preChargedDraft.refuseGroupLabel
      }

      if (this.$settings.preChargedDraft.refuseUsername !== undefined) {
        this.refuseUsername = this.$settings.preChargedDraft.refuseUsername
      }

      if (this.$settings.preChargedDraft.refuseReason !== undefined) {
        this.refuseReason = this.$settings.preChargedDraft.refuseReason
      }

      if (this.recipientZoneCode.label === 'GBP' && this.recipientBank !== '') {
        let extracted = extractForeignIban(this.recipientBank)
        this.sortCode = extracted.sortCode
        this.accountNumber = extracted.accountNumber
        this.recipientBank = ''
      }
      this.ImmPmtAccepted = this.$settings.preChargedDraft.ImmPmtAccepted
      if (this.$settings.preChargedDraft.idTeam !== undefined) {
        this.id_team = this.$settings.preChargedDraft.idTeam
        this.$engine.accounts.fetchPersonnalTeams().then(() => {
          this.label_team = this.$engine.accounts.getPersonnalTeams().filter(team => { return team.id_team === this.id_team })[0].team_label
        })
      }
      if (this.$settings.preChargedDraft.instantPayment !== undefined && this.$settings.preChargedDraft.instantPayment !== '') {
        this.instantPayment = this.$settings.preChargedDraft.instantPayment
      }
      if (this.$settings.preChargedDraft.decision !== undefined && this.$settings.preChargedDraft.decision !== '') {
        this.decision = this.$settings.preChargedDraft.decision
      }
    }

    this.$settings.preChargedDraft = undefined

    let contactsMap = this.contacts.map(function (obj) {
      let rObj = {}
      rObj[obj.label] = obj
      return rObj
    })
    let contactsMapObj = Object.assign({}, ...contactsMap)
    this.contactsPicker = this.$f7.picker({
      input: '#bookContacts',
      rotateEffect: true,
      cols: [
        {
          textAlign: 'center',
          values: Object.keys(contactsMapObj)
        }
      ],
      onClose: function (p) {
        that.recipientName = contactsMapObj[p.value].name
        that.recipientBank = contactsMapObj[p.value].iban
        that.recipientEmail = contactsMapObj[p.value].identifier
        that.contacts = contactsMapObj[p.value]
      }
    })

    let ibansMap = this.bankAccounts.map(function (obj) {
      let rObj = {}
      rObj[obj.name] = {iban: obj.iban, zone: obj.zoneCode}
      return rObj
    })
    let ibansMapObj = Object.assign({}, ...ibansMap)
    this.accountsPicker = this.$f7.picker({
      input: '#account-inputDP',
      rotateEffect: true,
      cols: [
        {
          textAlign: 'center',
          values: Object.keys(ibansMapObj)
        }
      ],
      onClose: function (p) {
        that.senderBank = ibansMapObj[p.value].iban
        that.senderBankName = p.value
        that.recipientZoneCode = ibansMapObj[p.value].zone
      },
      onOpen: function (p) {
        // that.senderBankName = p.value
      }
    })
    let params = {
      idAcct: this.$engine.user.get().id
    }
    that.$engine.attachments.getRefresh(params).then(response => {
      this.cloudFiles = response.data.docs
      let filesMap = this.cloudFiles.map(function (obj) {
        let rObj = {}
        rObj[obj.name] = {id: obj.id, name: obj.name, type: obj.type, internalReference: obj.internalReference}
        return rObj
      })
      let filesMapObj = Object.assign({}, ...filesMap)
      let values = []
      if (Object.keys(filesMapObj).length > 0) {
        values = Object.keys(filesMapObj)
        this.hasCloudAttachments = true
      } else {
        values = ['No attachments in MoneyRoad Cloud']
      }
      if (this.hasCloudAttachments) {
        this.cloudDocsPicker = this.$f7.picker({
          input: '#application-file-input',
          rotateEffect: true,
          cols: [
            {
              textAlign: 'center',
              values: values
            }
          ],
          onClose: function (p) {
            if (Object.keys(filesMapObj).length > 0) {
              if (filesMapObj[p.value].id !== that.attachmentId) {
                that.attachmentId = filesMapObj[p.value].id
                that.cloudFileSel()
              }
            }
          },
          onOpen: function (p) {
            if (Object.keys(filesMapObj).length > 0) {
              that.attachmentName = p.value
            }
          }
        })
      }

      let label = []
      this.countries.forEach((x, y) => {
        label.push(x.label)
      })
      that.countryPicker = this.$f7.picker({
        input: '#ListCountry',
        rotateEffect: true,
        cols: [
          {
            textAlign: 'center',
            values: label
          }
        ],
        onClose: function (p) {
          that.recipientZoneCode = p.value[0]
        }
      })
    })
    .catch(err => {
      errorMessageAlert(err, that)
    })
    this.clearance = this.$engine.user.get().clearance['Direct Payments']
    this.accountType = this.$engine.user.get().type

    if (this.attachmentId !== '$NotFound' && this.attachmentId !== undefined && this.attachmentId !== '') {
      this.hasAttachment = true
    }
  },
  beforeDestroy () {
    this.attachmentName = ''
    this.attachment = ''
    this.recipientName = ''
    this.recipientBank = ''
    this.senderBank = ''
    this.recipientEmail = ''
    this.remittanceInformation = ''
    this.executionDate = ''
    this.amount = ''
    this.attachmentReference = ''
    this.modificationAccepted = false
    this.attachmentId = ''
    this.loadingFile = ''
    this.fromCloud = ''
    this.bankAccounts = ''
    this.contacts = []
    this.cloudFiles = []
    this.ImmPmtAccepted = false
    this.cloudDocsPicker = ''
    this.accountsPicker = ''
    this.countryPicker = ''
    this.draftName = ''
    this.recipientZoneCode = {}
    this.id_team = ''
    this.label_team = ''

    let attachmentObj = {
      fromCloudList: false,
      id: 0,
      name: '',
      data: '',
      amount: 0,
      reference: '',
      debtorName: '',
      executionDate: ''
    }
    let draftObj = {
      Amount: '',
      AttachmentId: '',
      AttachmentName: '',
      AttachmentReference: '',
      CreditorBankAccount: '',
      CreditorIdentifier: '',
      DebtorBankAccount: '',
      DebtorIdentifier: '',
      DebtorName: '',
      ImmPmtAccepted: '',
      ModificationAccepted: '',
      PymtNtr: '',
      RemittanceInformation: '',
      RequestedExecutionDate: '',
      draftName: '',
      idAccount: '',
      idDraft: '',
      isComplete: '',
      recipientZoneCode: '',
      debtorZoneCode: ''
    }
    this.$engine.settings.set({preChargedFile: attachmentObj})
    this.$engine.settings.set({preChargedDraft: draftObj})
  },
  components: {
    JsPDF,
    'page-nav-bar': pageNavBar,
    'bottom-toolbar': bottomToolbar
  },
  watch: {
    loadingFile (val) {
      if (val) {
        this.$f7.showPreloader('Loading File')
      } else {
        this.$f7.hidePreloader()
      }
    }
  },
  methods: {
    /* TLV 23/01/2020
      Si le draft a été validé par le plus haut level pouvant le valider, alors il est directement envoyé
    */
    calcValidateAndSend () {
      if (this.capsule === 'draft-edit') {
        let maxLevelValue = Math.max.apply(Math, this.validators.map(function (v) { return v.level }))
        let levelSelected = this.validators.filter(v => { return v.groupId === this.idGroup })[0]
        if (levelSelected !== undefined) {
          levelSelected = levelSelected.level
          if (maxLevelValue === parseInt(levelSelected)) {
            return true
          }
        }
        return false
      }
      return false
    },
    rotateChevron ($event) {
      if (this.Dom7($event.target).parent().parent().parent().parent().hasClass('accordion-item-expanded') ||
          this.Dom7($event.target).parent().parent().parent().hasClass('accordion-item-expanded') ||
          this.Dom7($event.target).parent().parent().hasClass('accordion-item-expanded') ||
          this.Dom7($event.target).parent().hasClass('accordion-item-expanded')) {
        this.Dom7($event.target).find('i').transform('rotate(0deg)')
      } else {
        this.Dom7($event.target).find('i').transform('rotate(90deg)')
      }
    },
    changeSwitchModificationAccepted (obj) {
      this.modificationAccepted = obj.target.checked
    },
    hideBlock ($event) {
      let that = this
      if (that.Dom7($event.target).hasClass('card-header')) {
        if (that.Dom7($event.target).next().css('display') === 'none') {
          that.Dom7($event.target).next().show()
          that.Dom7($event.target).find('i').transform('rotate(90deg)')
        } else {
          that.Dom7($event.target).next().hide()
          that.Dom7($event.target).find('i').transform('rotate(0deg)')
        }
      } else {
        if (that.Dom7($event.target).parent().next().css('display') === 'none') {
          that.Dom7($event.target).parent().next().show()
          that.Dom7($event.target).parent().find('i').transform('rotate(90deg)')
        } else {
          that.Dom7($event.target).parent().next().hide()
          that.Dom7($event.target).parent().find('i').transform('rotate(0deg)')
        }
      }
      that.$$('.page-content').scrollTop(that.Dom7($event.target).offset().top + that.$$(that.$$('.page-content')[that.$$('.page-content').length - 1]).offset().top - 96, 400)
    },
    setContacts: function () {
      var contactList = {}
      for (var j = 0; j < this.$engine.contacts.get().length; j++) {
        var firstLetter = this.$engine.contacts.get(j).identifier.substr(0, 1).toUpperCase()
        if (!contactList.hasOwnProperty(firstLetter)) {
          contactList[firstLetter] = []
        }
        contactList[firstLetter].push({
          label: this.$engine.contacts.get(j).label,
          iban: this.$engine.contacts.get(j).iban,
          identifier: this.$engine.contacts.get(j).identifier,
          name: this.$engine.contacts.get(j).name,
          id: this.$engine.contacts.get(j).id,
          zoneCode: this.$engine.contacts.get(j).zoneCode
        })
        contactList[firstLetter].sort()
      }
      this.contactSelectionList = this.orderKeys(contactList)
    },
    setTeams () {
      let that = this
      // Init teams
      that.teams = that.$engine.accounts.getPersonnalTeams()
      // Init teams default select
      if ((typeof that.teams) !== 'undefined' && that.teams.length > 0) {
        that.id_team = that.teams[0].id_team
        // Init teams select options
        for (var i = 0; i < that.teams.length; i++) {
          that.teamOptions[i] = {value: that.teams[i].id_team, text: that.teams[i].team_label}
        }
      }
    },
    onFileChange (e) {
      var files = e.target.files || e.dataTransfer.files
      if (!files.length) { return }
      if (files[0].size <= 500000000) {
        this.createImage(files[0])
        this.attachmentName = files[0].name
        this.Dom7(this.Dom7('.fileNameDisplay')[this.Dom7('.fileNameDisplay').length - 1]).val(this.attachmentName)
      } else {
        this.$f7.alert(this.$i18n.t('creation_forms.file_size') + Math.round(files[0].size / 1000) + this.$i18n.t('creation_forms.max_file_size'))
      }
    },
    orderKeys: function (obj, expected) {
      var keys = Object.keys(obj).sort(function keyOrder (k1, k2) {
        if (k1 < k2) return -1
        else if (k1 > k2) return +1
        else return 0
      })
      var i
      var after = {}
      for (i = 0; i < keys.length; i++) {
        after[keys[i]] = obj[keys[i]]
        delete obj[keys[i]]
      }
      for (i = 0; i < keys.length; i++) {
        obj[keys[i]] = after[keys[i]]
      }
      return obj
    },
    switched () {
      this.fromCloud = !this.fromCloud
      this.attachmentName = ''
      this.attachement = ''
      this.attachmentId = ''
    },
    cloudFileSel () {
      const that = this
      this.loadingFile = true
      this.$engine.attachments.download(that.attachmentId.toString())
        .then(response => {
          that.attachmentName = response.data.document_name
          that.attachement = response.data.document_data
          that.loadingFile = false
          that.attachmentReference = response.data.internal_reference
          that.Dom7('.fileNameDisplay').text(that.attachmentName)
        })
        .catch(error => {
          errorMessageAlert(error, that)
        })
    },
    clearAttachement () {
      this.attachement = ''
      this.attachmentName = ''
      this.attachmentReference = ''
      this.attachmentId = ''
      this.hasAttachment = false
    },
    createImage (file) {
      var that = this
      var reader = new FileReader()
      reader.onload = (e) => {
        that.attachement = e.target.result
        if (that.isOcrActive === true) {
          that.executeOCR(this.$li18n('attachments.refnd'), that.attachement)
        }
      }
      reader.readAsDataURL(file)
    },
    removeImage: function (e) {
      this.attachement = ''
    },
    convertDateFormat () {
      this.executionDate = moment(this.executionDate).format('YYYY-MM-DD')
    },
    formatIban () {
      if (this.recipientZoneCode.accountNumberField === 2) {
        if (validateAccountFormat(this.sortCode, this.recipientZoneCode.regexControl[0]) === null || validateAccountFormat(this.accountNumber, this.recipientZoneCode.regexControl[1]) === null) {
          this.recipientBank = ''
        } else {
          this.recipientBank = createIbanUK(this.sortCode, this.accountNumber)
        }
      }
    },
    SaveInDraft (namedraft, validateD = 0, directlySend = 0) {
      let that = this
      let payNat = this.ImmPmtAccepted ? 'IMMED' : 'TERM'
      let payModAcc = this.modificationAccepted ? 'true' : 'false'
      this.convertDateFormat()
      this.formatIban()
      if (validateD === '1') {
        let errFlag = this.verificationsDPValid()
        if (errFlag) {
          return
        }
      }
      let draftArray = []
      if (that.capsule === 'draft-edit') {
        // let userLogin = that.$engine.accounts.get()[0].userAccts.filter(user => user.id === that.$engine.user.userAccountId)[0].login
        // let senderName = that.$engine.accounts.get().filter(user => user.identifier === userLogin)[0].name
        if (that.recipientZoneCode.label === 'GBP') {
          this.recipientBankAccount = createIbanUK(this.sortCode, this.accountNumber)
        }
        draftArray.push({
          'idDraft': that.idDraft,
          'idAccount': this.$engine.user.get().id,
          'CreditorBankAccount': this.recipientBankAccount,
          'CreditorIdentifier': this.recipientEmail,
          'CreditorName': this.beneficiaire,
          'DebtorName': this.$engine.user.get().name,
          'DebtorBankAccount': that.senderBank,
          'DebtorIdentifier': this.$engine.user.get().identifier,
          'RemittanceInformation': that.remittanceInformation,
          'ImmPmtAccepted': payModAcc,
          'PymtNtr': payNat,
          'RequestedExecutionDate': that.executionDate,
          'Amount': that.amount,
          'ModificationAccepted': that.modificationAccepted,
          'AttachmentId': that.attachmentId,
          'AttachmentName': that.attachmentName,
          'AttachmentReference': that.attachmentReference,
          'Attachment': that.attachement,
          'DraftName': that.draftName,
          'creditorZoneCode': that.selectedDebtor.zoneCode,
          'debtorZoneCode': that.senderZoneCodeLabel,
          'validate': validateD,
          'groupValidator': this.idGroup,
          'validator': this.$engine.user.userAccountId,
          'refuseReason': this.refuseReason,
          'instantPayment': that.instantPayment,
          'creditorDecision': that.decision,
          'currency': that.senderZoneCodeLabel,
          'activateOCR': that.isOcrActive === true ? '1' : '0'
        })
        this.$engine.dpDrafts.update(draftArray[0])
        .then(response => {
          if (response.status === 200) {
            /* TLV 23/01/2020
              Si le draft a été validé par le plus haut level pouvant le valider, alors il est directement envoyé
            */

            if (validateD === '1' && this.ableToValidateAndSend && directlySend === '1') {
              this.sendDirectPayments(validateD, this.$engine.user.get().name)
            } else {
              this.$f7.modal({
                title: that.saveMessage,
                text: '<span class="preloader"></span>'
              })
              setTimeout(function () {
                that.$f7.closeModal()
                loadPage(that, {url: '/directPayments/sendbox/draft', force: false, ignoreCache: false})
              }, 2000)
            }
          }
        })
        .catch(err => {
          errorMessageAlert(err, this)
        })
      } else {
        if (that.recipientZoneCode.label === 'GBP') {
          this.recipientBankAccount = createIbanUK(this.sortCode, this.accountNumber)
        }
        draftArray.push({
          'idDraft': that.idDraft,
          'idAccount': this.$engine.user.get().id,
          'CreditorBankAccount': this.recipientBankAccount,
          'CreditorIdentifier': this.recipientEmail,
          'CreditorName': this.beneficiaire,
          'DebtorName': this.$engine.user.get().name,
          'DebtorBankAccount': that.senderBank,
          'DebtorIdentifier': this.$engine.user.get().identifier,
          'RemittanceInformation': that.remittanceInformation,
          'ImmPmtAccepted': payModAcc,
          'PymtNtr': payNat,
          'RequestedExecutionDate': that.executionDate,
          'Amount': that.amount,
          'ModificationAccepted': that.modificationAccepted,
          'AttachmentId': that.attachmentId,
          'AttachmentName': that.attachmentName,
          'AttachmentReference': that.attachmentReference,
          'Attachment': that.attachement,
          'DraftName': namedraft,
          'creditorZoneCode': that.selectedDebtor.zoneCode,
          'debtorZoneCode': that.senderZoneCodeLabel,
          'id_team': this.isSmartphone ? this.id_team[0] : this.id_team,
          'id_creator': this.$engine.user.userAccountId,
          'instantPayment': that.instantPayment,
          'creditorDecision': that.decision,
          'currency': that.senderZoneCodeLabel,
          'activateOCR': that.isOcrActive === true ? '1' : '0'
        })
        let requestLoad = {
          'drafts': draftArray
        }
        that.$engine.dpDrafts.create(requestLoad)
        .then(response => {
          if (response.status === 200) {
            this.$f7.modal({
              title: that.saveMessage,
              text: '<span class="preloader"></span>'
            })
            if (that.capsule === 'draft-create' || that.capsule === 'direct-payment-create') {
              setTimeout(function () {
                that.$f7.closeModal()
                loadPage(that, {url: '/directPayments/sendbox/draft', force: false, ignoreCache: false})
              }, 2000)
            } else {
              setTimeout(function () {
                that.$f7.closeModal()
                that.Dom7('.attachmentTaphold').removeClass('listItemSelected')
              }, 2000)
            }
          }
        })
        .catch(error => {
          errorMessageAlert(error, that)
        })
      }
    },
    valideDraft () {
      this.SaveInDraft('', '1')
    },
    valideAndSendDraft () {
      this.SaveInDraft('', '1', '1')
    },
    refuseDraft () {
      let that = this
      this.$f7.modal({
        title: 'Enter a reason for rejecting the draft:',
        afterText: '<div class="item-input"><textarea class="inputrefusereason"></textarea></div>',
        buttons: [
          {
            text: 'Cancel',
            color: 'red',
            onClick: function () {
            }
          },
          {
            text: 'Save',
            onClick: function () {
              that.refuseReason = that.Dom7('.inputrefusereason').val()
              that.SaveInDraft('', '2')
            }
          }
        ]
      })
    },
    getNameDraft () {
      var namedraft = ''
      let that = this
      if (this.capsule === 'draft-create' || this.capsule === 'direct-payment-create') {
        this.$f7.modal({
          title: 'Please enter a name for your draft',
          // text: 'Enter a name of draft',
          afterText: '<div class="item-input"><input class="inputnamedraft" type="text"></div>',
          buttons: [
            {
              text: 'Cancel draft',
              color: 'red',
              onClick: function () {
              }
            },
            {
              text: 'Save draft',
              onClick: function () {
                let namedraft = that.Dom7('.inputnamedraft').val()
                that.SaveInDraft(namedraft)
              }
            }
          ]
        })
      } else {
        this.SaveInDraft(namedraft)
      }
    },
    verificationsDPValid () {
      let that = this
      this.recipientBankAccount = createForeignIban(this.recipientZoneCode)
      this.formatIban()

      this.sendPaymentsClicked = true
      let returnFlag = false
      let requestDetailsBlockFlag = false
      let debtorFlag = false
      let creidtorFlag = false
      let recipientBankFlag = false
      let remittanceInformationFlag = false
      let executionDateFlag = false
      let tooEarlyDateFlag = false
      let amountFlag = false
      let amountMaxFlag = false
      let amountMinFlag = false

      let maxAmountAuthorized = this.$engine.settings.directPayments.get().max_amount

      if (this.beneficiaire === '' | (this.recipientEmail === '' && this.mandatoryDebtorEmail) | this.recipientBankAccount === '') {
        that.$$('.recipientBlock').show()
        that.$$('.recipientChevron').transform('rotate(90deg)')
        returnFlag = true
        debtorFlag = true
      }
      if (this.senderBank === '') {
        that.$$('.myAccountBlock').show()
        that.$$('.senderChevron').transform('rotate(90deg)')
        returnFlag = true
        creidtorFlag = true
      }

      for (var i = 0; i < this.recipientZoneCode.accountNumberField; i++) {
        if (this.recipientZoneCode.values[this.recipientZoneCode.accountLabel[i]] != null &&
            this.recipientZoneCode.values[this.recipientZoneCode.accountLabel[i]]) {
          if (validateAccountFormat(this.recipientZoneCode.values[this.recipientZoneCode.accountLabel[i]], this.recipientZoneCode.regexControl[i]) === null) {
            returnFlag = true
            recipientBankFlag = true
          }
        }
      }

      if (this.remittanceInformation === '') {
        requestDetailsBlockFlag = true
        returnFlag = true
        remittanceInformationFlag = true
      }
      if (this.executionDate === '') {
        requestDetailsBlockFlag = true
        returnFlag = true
        executionDateFlag = true
      }
      if (this.amount === '') {
        requestDetailsBlockFlag = true
        returnFlag = true
        amountFlag = true
      }
      if (parseInt(that.amount) > parseInt(maxAmountAuthorized)) {
        returnFlag = true
        amountMaxFlag = true
      }
      if (parseInt(that.amount) <= 0) {
        returnFlag = true
        amountMinFlag = true
      }

      if (requestDetailsBlockFlag) {
        that.$$('.requestDetailsBlock').show()
        that.$$('.detailChevron').transform('rotate(90deg)')
      }

      if (recipientBankFlag) {
        this.$f7.alert(
                  this.$i18n.t('errors.change_to_valid',
                    {invaliddata: this.$i18n.t('bank_info_min')}),
                  this.$i18n.t('errors.invalid_data_format',
                    {invaliddata: this.$i18n.t('bank_info_min')})
          )
      } else if (debtorFlag && !creidtorFlag && !remittanceInformationFlag && !executionDateFlag && !amountFlag && !tooEarlyDateFlag) {
        this.$f7.alert('Please enter a creditor.', 'Missing creditor')
      } else if (!debtorFlag && creidtorFlag && !remittanceInformationFlag && !executionDateFlag && !amountFlag && !tooEarlyDateFlag) {
        this.$f7.alert('Please enter a debtor.', 'Missing debtor')
      } else if (!debtorFlag && !creidtorFlag && remittanceInformationFlag && !executionDateFlag && !amountFlag && !tooEarlyDateFlag) {
        this.$f7.alert('Please enter a reason', 'Missing reason')
      } else if (!debtorFlag && !creidtorFlag && !remittanceInformationFlag && executionDateFlag && !amountFlag && !tooEarlyDateFlag) {
        this.$f7.alert('Please enter an execution date', 'Missing execution date')
      } else if (!debtorFlag && !creidtorFlag && !remittanceInformationFlag && !executionDateFlag && amountFlag && !tooEarlyDateFlag) {
        this.$f7.alert('Please enter an amount.', 'Missing amount')
      } else if (amountMaxFlag) {
        this.$f7.alert('If you really want to send the amount you entered, please update your settings or contact your supervisor to update the maximum amount permitted.', 'The maximum amount permitted is less than '.concat(maxAmountAuthorized, ' €.'))
      } else if (amountMinFlag) {
        this.$f7.alert('Please enter an amount positive', 'Incorrect amount')
      } else if (!debtorFlag && !creidtorFlag && !remittanceInformationFlag && !executionDateFlag && !amountFlag) {
      } else {
        this.$f7.alert('', 'Missing data')
      }

      return returnFlag
    },
    sendDirectPayments: function (validateD = 0, senderName = '') {
      let that = this
      let requestAlertText = this.$i18n.t('loading.sending')
      let responseAlertText = this.$i18n.t('success.DP_sent')

      let errFlag = this.verificationsDPValid()

      if (errFlag) {
        return
      }

      if (this.identifier.length > 0) {
        if (validateEmail(this.identifier) === null && validateSIREN(this.identifier) === null) {
          this.$f7.alert('Change the identifier format', 'Invalid Identifier')
          return
        }
      }
      this.executionDate = moment(this.executionDate).format('YYYY-MM-DD')
      this.$f7.showPreloader(requestAlertText)
      that.$engine.services.directPayments
      .create({
        creditorIdentifier: that.recipientEmail,
        creditorName: that.beneficiaire,
        creditorBankAccount: that.recipientBankAccount,
        creditorZoneCode: that.selectedDebtor.zoneCode,
        debtorZoneCode: that.senderZoneCodeLabel,
        debtorIdentifier: this.$engine.user.get().identifier,
        debtorName: (this.accountType === '1' && validateD === '1' && this.ableToValidateAndSend) ? senderName : this.$engine.user.get().name,
        debtorBankAccount: that.senderBank,
        amount: that.amount,
        currency: that.senderZoneCodeLabel,
        executionDate: that.executionDate,
        reason: that.remittanceInformation,
        attachmentName: that.attachmentName,
        attachmentReference: that.attachmentReference,
        attachmentData: that.attachement,
        attachmentId: that.attachmentId,
        idDraft: that.idDraft,
        instantPayment: that.instantPayment,
        creditorDecision: that.decision
      })
      .then(response => {
        that.status = response.status
        if (response.status === 200) {
          that.$f7.hidePreloader()
          this.$f7.modal({
            title: responseAlertText,
            text: '<span class="preloader"></span>'
          })
          this.$engine.services.directPayments.debtorList = []
          this.$engine.services.directPayments.contactDebtorList = []
          setTimeout(function () {
            that.$f7.closeModal()
            loadPage(that, {url: '/directPayments/sendbox/'})
          }, 2000)
        }
      })
      .catch(error => {
        errorMessageAlert(error, that)
      })
    },
    accountPicker (e) {
      e.stopPropagation()
      this.accountsPicker.open()
    },
    countriesPicker (e) {
      e.stopPropagation()
      this.countryPicker.open()
    },
    teamPicker (e) {
      e.stopPropagation()
      this.teamsPicker.open()
    },
    createTeamPicker () {
      let that = this
      this.teams = this.$engine.accounts.getPersonnalTeams()
      this.teamsPicker = this.$f7.picker({
        input: '#teamSelect',
        rotateEffect: true,
        cols: [
          {
            textAlign: 'center',
            values: that.teams.map(team => { return team.team_label })
          }
        ],
        onClose: function (p) {
          // Store team that has selected label
          let selectedTeam = that.teams.filter(team => { return team.team_label === p.value[0] })
          // If team exists, get it's id and label
          if (selectedTeam.length > 0) {
            selectedTeam = selectedTeam[0]
            that.id_team = selectedTeam.id_team
            that.label_team = selectedTeam.team_label
          }
        }
      })
    },
    filesPicker (e) {
      e.stopPropagation()
      // if (this.loadingFile === true || !this.fromCloud) { return }
      this.cloudDocsPicker.open()
    },
    debtorPicker (e) {
      e.stopPropagation()
      if (this.loadingFile === true) { return }
      this.contactsPicker.open()
    },
    openCreateAttachmentInvoice () {
      loadPage(this, {url: '/attachments/createInvoice/'})
    },
    openImportAttachment () {
      let that = this
      let buttons1
      if (this.hasCloudAttachments) {
        buttons1 = [
          {
            text: 'Import from device',
            onClick: function () {
              that.attachement = ''
              that.attachmentName = ''
              that.attachmentId = ''
              that.Dom7(that.Dom7('.local-file-input')[that.Dom7('.local-file-input').length - 1]).click()
            }
          },
          {
            text: 'Import from MoneyRoad',
            onClick: function (event, event2) {
              that.attachement = ''
              that.attachmentName = ''
              that.attachmentId = ''
              that.filesPicker(event2)
            }
          },
          {
            text: 'Cancel',
            color: 'red',
            onClick: function () {
            }
          }
        ]
      } else {
        buttons1 = [
          {
            text: 'Import from device',
            onClick: function () {
              that.attachement = ''
              that.attachmentName = ''
              // that.attachmentReference = ''
              that.attachmentId = ''
              that.Dom7(that.Dom7('.local-file-input')[that.Dom7('.local-file-input').length - 1]).click()
            }
          },
          {
            text: 'Cancel',
            color: 'red',
            onClick: function () {
            }
          }
        ]
      }
      this.$f7.actions(buttons1)
    },
    calendar ($event) {
      /* eslint-disable no-undef */
      let that = this

      if (that.$f7.device.os === 'android' || that.$f7.device.os === 'ios') {
        var options = {
          date: new Date(),
          mode: 'date'
        }
        datePicker.show(options, function (date) {
          let year = date.getFullYear().toString()
          let month = (date.getMonth() + 1).toString().length > 1 ? (date.getMonth() + 1).toString() : '0' + (date.getMonth() + 1).toString()
          let day = date.getDate().toString().length > 1 ? date.getDate().toString() : '0' + date.getDate().toString()
          let dateResult = year + '-' + month + '-' + day
          that.executionDate = dateResult
        })
      } else {
      }
      /* eslint-enable no-undef */
    },
    paymentsDate () {
      if (this.executionDate !== undefined) {
        if (this.executionDate.length > 0) {
          return this.executionDate
        } else {
          return 'Select a date'
        }
      } else {
        return 'Select a date'
      }
    },
    scanOrder ($event) {
      /* eslint-disable no-undef */
      let that = this
      var options = {
        quality: 10,
        destinationType: Camera.DestinationType.FILE_URI,
        sourceType: Camera.PictureSourceType.CAMERA,
        encodingType: Camera.EncodingType.JPEG,
        mediaType: Camera.MediaType.PICTURE,
        allowEdit: true,
        correctOrientation: true
      }

      if (this.$engine.settings.directPayments.get().ocrActivation === '1') {
        navigator.camera.getPicture(function cameraSuccess (imageUri) {
          window.resolveLocalFileSystemURL(imageUri, function (entry) {
            entry.file(function (file) {
              var reader = new FileReader()

              reader.onloadend = function (e) {
                executeOCR('Order', e.target.result.split(',')[1])
              }
              reader.readAsDataURL(file)
            }, function () {
              console.log('Error: Creating File object error.')
            })
          }, function () {
            console.log('Error: Resolving URL error.')
          })
        }, function cameraError (error) {
          console.debug('Unable to obtain picture: ' + error, 'app')
        }, options)
      } else {
        console.log('OCR Non Actif')
        navigator.camera.getPicture(function cameraSuccess (imageUri) {
          window.resolveLocalFileSystemURL(imageUri, function (entry) {
            entry.file(function (file) {
              var reader = new FileReader()
              reader.onloadend = function (e) {
                that.attachement = e.target.result
              }

              let ca = that
              that.$f7.modal({
                title: 'Please enter the name of the scan',
                // text: 'Enter a name of draft',
                afterText: '<div class="item-input"><input class="inputnamescan" type="text"></div>',
                buttons: [
                  {
                    text: 'Cancel',
                    color: 'red',
                    onClick: function () {
                    }
                  },
                  {
                    text: 'Done',
                    onClick: function () {
                      var lab = ca.Dom7('.inputnamescan').val()
                      ca.attachmentName = lab
                    }
                  }
                ]
              })
              that.attachmentReference = ''
              that.attachmentId = ''

              reader.readAsDataURL(file)
            }, function () {
              console.log('Error: Creating File object error.')
            })
          }, function () {
            console.log('Error: Resolving URL error.')
          })
        }, function cameraError (error) {
          console.debug('Unable to obtain picture: ' + error, 'app')
        }, options)
      }
      /* eslint-enable no-undef */
    },
    scanRIB ($event) {
      /* eslint-disable no-undef */
      var options = {
        quality: 10,
        destinationType: Camera.DestinationType.FILE_URI,
        sourceType: Camera.PictureSourceType.CAMERA,
        encodingType: Camera.EncodingType.JPEG,
        mediaType: Camera.MediaType.PICTURE,
        allowEdit: true,
        correctOrientation: true
      }

      if (this.$engine.settings.directPayments.get().ocrActivation === '1') {
        navigator.camera.getPicture(function cameraSuccess (imageUri) {
          window.resolveLocalFileSystemURL(imageUri, function (entry) {
            entry.file(function (file) {
              var reader = new FileReader()
              reader.onloadend = function (e) {
                executeOCR('RIB', e.target.result.split(',')[1])
              }
              reader.readAsDataURL(file)
            }, function () {
              console.log('Error: Creating File object error.')
            })
          }, function () {
            console.log('Error: Resolving URL error.')
          })
        }, function cameraError (error) {
          console.debug('Unable to obtain picture: ' + error, 'app')
        }, options)
      }
      /* eslint-enable no-undef */
    },
    importRIB ($event) {
      this.Dom7(this.Dom7('.rib-file-input')[this.Dom7('.rib-file-input').length - 1]).click()
    },
    executeOCROnRIB (e) {
      var files = e.target.files || e.dataTransfer.files
      if (!files.length) { return }
      if (files[0].size <= 50000000) {
        let that = this
        var reader = new FileReader()
        reader.onload = (e) => {
          that.executeOCR('RIB', e.target.result)
        }
        return reader.readAsDataURL(files[0])
      } else {
        this.$f7.alert('This file has a size of ' + Math.round(files[0].size / 1000) + 'Kb. \n Maximum permited is 50Mo', 'Maximum file size exceeded')
      }
    },
    /** @author ERI- TLV
    * @date 27/03/2020
    * @brief méthode qui execute l'OCR à partir de l'Order transmis en paramètre
    *     et qui affiche les données retournées sur l'IHM
    * @param filetype may be: RIB, Invoice, Order
    * @param file est l'image chiffrée en base64
    */
    executeOCR (filetype, file) {
      let that = this
      // key : IHM reception parameter, value : OCR returned data
      let exchangeData = {
        'RIB': {
          creditorBankAccount: 'iban',
          beneficiaire: 'name'
        },
        'Order': {
          debtorName: 'debtorName',
          beneficiaire: 'beneficiary',
          creditorBankAccount: 'creditorBankAccount',
          remittanceInformation: 'reason',
          debtorBank: 'debtorBankAccount',
          debtorEmail: 'creditorMail',
          amount: 'amount',
          executionDate: 'date',
          attachmentReference: 'reference'
        }
      }
      that.$f7.showPreloader(that.$i18n.t('sent.ocr_loading'))
      return that.$engine.services.ocr(
        that.$engine.user.get().id,
        '',
        file,
        'jpeg',
        'scan',
        filetype
      ).then(response => {
        that.$f7.hidePreloader()
        that.$f7.modal({
          title: that.$i18n.t('sent.ocr_end'),
          text: '<span class="preloader"></span>'
        })
        that.$f7.hidePreloader()
        that.$f7.closeModal()
        response = response.data
        // Pour l'instant l'OCR ne marche qu'avec des IBAN
        this.recipientZoneCode = this.$engine.bankAccounts.getZoneData('EUR')
        for (var key in exchangeData[filetype]) {
          if (response[exchangeData[filetype][key]] === '$Error' ||
              response[exchangeData[filetype][key]] === '$NotFound') {
            response[exchangeData[filetype][key]] = ''
          }
          that[key] = response[exchangeData[filetype][key]]
        }

        /* TLV 03/2020 : Si l'IBAN expéditeur est reconnu par l'OCR, il n'est ajouté
          que s'il fait partie des comptes bancaires de l'utilisateur */
        if (response.debtorBankAccount != null) {
          let bankAccountsList = that.bankAccounts
          for (var bank in bankAccountsList) {
            if (response.debtorBankAccount === bankAccountsList[bank].iban) {
              that.senderBank = bankAccountsList[bank].iban
            }
          }
        }
      })
      .catch(err => {
        that.$f7.hidePreloader()
        that.$f7.closeModal()
        alert(that.$i18n.t('errors.too_important_tilt') + ' ' + err)
        console.log(that.$i18n.t('errors.too_important_tilt') + ' ' + err)
      })
    },
    view (id) {
      // Get cloudDocument
      // var resource = 'attachment/detail/' + id
      const that = this
      this.$f7.showPreloader('Opening File')
      this.$engine.services.payments.getAttachmentDetail(id)
        .then(response => {
          this.$engine.settings.set({Attachment: {
            data: response.data.documentData,
            name: response.data.documentName,
            mimeType: response.data.documentData.split(';')[0].replace(/^data:/, ''),
            id: id
          }})
          if (that.$f7.device.os === 'android' || that.$f7.device.os === 'ios') {
            that.writeToFile(
              response.data.documentName,
              response.data.documentData,
              response.data.documentData.split(';')[0].replace(/^data:/, ''),
              true,
              function (filePath, fileType, fileName) {
                that.readFile(filePath, fileType, fileName)
              },
              function () {
                that.$f7.alert('', 'Error creating the file')
              }
            )
          } else {
            let blob = b64toBlob(response.data.documentData.split(',')[1], response.data.documentData.split(';')[0].replace(/^data:/, ''))
            const url = window.URL.createObjectURL(blob)
            const fileLink = document.createElement('a')
            fileLink.href = url
            fileLink.setAttribute('download', response.data.documentName) // or any other extension
            fileLink.click()
          }
          setTimeout(function () { that.$f7.hidePreloader() }, 1000)
        })
        .catch(error => {
          that.$f7.hidePreloader()
          errorMessageAlert(error, that)
          // errorMessageAlert(error, that)
        })
    },
    writeToFile (fileName, data, fileType, readonly, success, error) {
      /* eslint-disable no-undef */
      let that = this
      let directory = ''

      if (readonly) {
        if (that.$f7.device.os === 'android') {
          directory = cordova.file.externalDataDirectory
        } else if (that.$f7.device.os === 'ios') {
          directory = cordova.file.tempDirectory
        } else {
          directory = cordova.file.dataDirectory
        }
        that.saveFileToDirectory(fileName, data, fileType, directory, success, error)
      } else {
        // directory = cordova.file.externalRootDirectory
        if (that.$f7.device.os === 'android') {
          directory = cordova.file.externalRootDirectory
        } else if (that.$f7.device.os === 'ios') {
          // directory = cordova.file.dataDirectory
          directory = cordova.file.tempDirectory
        } else {
          directory = cordova.file.dataDirectory
        }
        try {
          that.checkForWritePermissions(function () {
            try {
              window.resolveLocalFileSystemURL(directory, function (directoryEntry) {
                directoryEntry.getDirectory('Download', {create: true}, function (downloadDir, _data) {
                  that.saveFileToDirectory(fileName, data, fileType, downloadDir.nativeURL, function (filePath, fileType) {
                    console.log('sucess saving file: ', filePath)
                  }, function (error, _data) {
                    console.error('error on saving file' + error.code)
                    alert('Unable to save file: ' + error.code)
                  })
                }, function (error, _data) {
                  console.error('error on accessing download directory' + error.code)
                  alert('Unable to get/create download directory: ' + error.code)
                })
              }, (e, file) => { // error resolveLocalFileSystemURL
              })
            } catch (error) { // get dir
              console.error(error)
            }
          }, function () {
            alert('App needs access to the phone\'s file storage in order to save files.')
          })
        } catch (error) { // get perms
          console.error(error)
        }
      }
      /* eslint-enable no-undef */
    },
    /* Only work for downloading files on Mobile devices */
    download (id) {
      /* eslint-disable no-undef */
      const that = this
      this.$f7.showPreloader('Downloading File')
      this.$engine.services.payments.getAttachmentDetail(id)
        .then(response => {
          that.$f7.hidePreloader()
          this.$engine.settings.set({Attachment: {
            data: response.data.documentData,
            name: response.data.documentName,
            mimeType: response.data.documentData.split(';')[0].replace(/^data:/, ''),
            id: id
          }})
          that.writeToFile(
            response.data.documentName,
            response.data.documentData,
            response.data.documentData.split(';')[0].replace(/^data:/, ''),
            false,
            function (filePath, fileType) {
              that.$f7.alert(filePath.split('/')[filePath.split('/').length - 1], 'Following file successfully saved.')
            },
            function () {
              that.$f7.alert('', 'Error creating the file')
            }
          )
        })
        .catch(error => {
          that.$f7.hidePreloader()
          errorMessageAlert(error, that)
        })
      /* eslint-enable no-undef */
    },
    readFile (filePath, fileType, fileName) {
      /* eslint-disable no-undef */
      // TODO : test fileType before trying to open and let the user know
      window.resolveLocalFileSystemURL(filePath, function (entry) {
        cordova.plugins.fileOpener2.open(entry.nativeURL.replace(/%20/g, ' '), fileType, {
          error: function (e) {
            // TODO : screen user stuff
          },
          success: function (s) {
            // TODO : screen user stuff
          }
        })
      })
      // cordova.plugins.fileOpener2.open(file, fileType, {
      //   error: function (e) {
      //     // TODO : screen user stuff
      //     console.log('---------error----------')
      //   },
      //   success: function (s) {
      //     // TODO : screen user stuff
      //     console.log('---------success----------')
      //   }
      // })
      /* eslint-enable no-undef */
    },
    saveFileToDirectory (fileName, data, fileType, directory, success, error) {
      /* eslint-disable no-undef */
      let directoryEntryReference = null
      window.resolveLocalFileSystemURL(directory, function (directoryEntry) {
        directoryEntryReference = directoryEntry
        directoryEntry.getFile(fileName, { create: true, exclusive: true }, function (fileEntry) {
          fileEntry.createWriter(function (fileWriter) {
            fileWriter.onwriteend = function (e) {
              success(e.target.localURL, fileType, fileName)
            }
            fileWriter.onerror = function (e) {
              error()
            }
            let blob = b64toBlob(data.replace(/^data:\w+\/\w+;base64,/, ''), fileType)
            fileWriter.write(blob)
          }, (e, file) => {
          })
        }, (e, file) => {
          navigator.notification.confirm('This file already exists do you want to override it ? (' + fileName + ')', function (index) {
            console.log('Do you want to override the following file: ' + fileName + ' (' + index + ')')
            switch (index) {
              case 1: // No
                console.log('No. Returning to idle state.')
                break
              case 2: // Yes -> overrides  the file
                console.log('Yes. Overriding file.')
                directoryEntryReference.getFile(fileName, { create: true, exclusive: false }, function (fileEntry) {
                  fileEntry.createWriter(function (fileWriter) {
                    fileWriter.onwriteend = function (e) {
                      success(e.target.localURL, fileType, fileName)
                    }
                    fileWriter.onerror = function (e) {
                      error()
                    }
                    let blob = b64toBlob(data.replace(/^data:\w+\/\w+;base64,/, ''), fileType)
                    fileWriter.write(blob)
                  }, (e, file) => {
                  })
                }, (e, file) => {
                })
                break
            }
          }, 'Information', ['No', 'Yes'])
        })
      }, (e, file) => { // error resolveLocalFileSystemURL
      })
      /* eslint-enable no-undef */
    }
  }
}
</script>

<style scoped>
#cloud-label {
  color: #12bcf1;
  width: 30%;
  background-color: #e6e7e8;
  padding: 3px 3px 3px 3px;
  text-align: center;
  display: inline-block;
  border-style: solid;
  border-width: 1px;
  border-radius: 5px;
  border-color: #12bcf1;
}
.test-content{
  border-style: solid;
  border-width: 1px;
  border-color: #EBEBED;

	min-height: 15px;

	box-sizing: border-box;
  padding-left: 15px;
  display: flex;
  -webkit-box-pack: justify;
  justify-content: space-between;
  -webkit-box-align: center;
  align-items: center;
}
.test-inner{
  min-height: 15px;
  padding-right: 15px;
  position: relative;
  width: 100%;
  padding-top: 8px;
  padding-bottom: 7px;

  box-sizing: border-box;
  display: flex;
  -webkit-box-flex: 1;

  overflow: hidden;
  -webkit-box-pack: justify;
  justify-content: space-between;
  -webkit-box-align: center;
  align-items: center;
  align-self: stretch;
}
.test-title{
  color: #0E0144;
  flex-shrink: 1;
  min-width: 0;
  white-space: nowrap;
  position: relative;
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: 100%;
}
.test-after{
  max-width: 70%;
  overflow: hidden;
  text-overflow: ellipsis;
  position: relative;
  display: block;
  white-space: nowrap;
  color: #8e8e93;
  flex-shrink: 0;
  margin-left: auto;
  padding-left: 5px;
  max-height: 28px;
}
.grayEmpty{
  background-color: #f7f7f7;
}
.subtitleDebtorList {
  color: #000000;
}
.paymentsRequestSubOption {
  font-size: 14px;
}
.paymentsRequestSubOption input::-webkit-input-placeholder {
  font-size: 14px;
}
.formLabelPayment{
    min-width: 65px !important;
    width: 40% !important;
    font-size: 12px;
}
.paymentsRequestAddOtherDebtor {
  margin-left: 7px !important;
  float: right !important;
  position: relative !important;
  color: #777777;
}
.negotiateSwitch {
  width: auto !important;
  margin-right: 30px;
}
.formTitle {
  color:white !important;
  text-align: center;
  margin: auto;
}
.facturePart2 {
  color: black;
}
.custom-item-inner {
  width: 100%;
  padding: 8px 15px 7px 0px;
}
.Column50 {
  width: 50% !important;
}
.paymentsButtonLength {
  width: 113px;
}
.attachmentButton {
  min-width: 80px;
}
ul {
  margin-left: -35px;
}
.input-group-text {
  font-size: small !important;
}
</style>



// WEBPACK FOOTER //
// DPCreateTemplate.vue?2ad11a39